<template>
  <div />
</template>

<script>
import { mapActions } from 'vuex'

export default {
  async created() {
    const workspaces = await this.fetchWorkspaces()
    if (workspaces.length) {
      this.$router.replace({ name: 'Workspace', params: { id: workspaces[0].id } })
      return
    }
    const ws = await this.createWorkspace('Default')
    this.$router.replace({ name: 'Workspace', params: { id: ws.id } })
  },
  methods: {
    ...mapActions('workspace', ['fetchWorkspaces', 'createWorkspace']),
  },
}
</script>
